import { useQuery } from '@tanstack/react-query'
import { fuzzySearchPositions } from 'api/positions/fuzzySearchPositions'
import { positionsKeys } from './keys'

export const fetchFuzzySearchPositions = (search: string, limit = 20) =>
  fuzzySearchPositions(search, limit)

export function useFuzzySearchPositionsQuery({
  search,
  limit = 10,
  enabled = true,
}: {
  search: string
  limit?: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: positionsKeys.fuzzySearch({ search, limit }),
    queryFn: () => fetchFuzzySearchPositions(search, limit),
    enabled: enabled && search.trim().length > 0,
  })
}
